import { Controller } from "@hotwired/stimulus"
import { createIcons, icons } from 'lucide'

export default class extends Controller {
  static targets = ["content", "wordCount"]

  static values = {
    projectTitle: String,
    fontFamily: { type: String, default: "EB Garamond" }
  }

  connect() {
    this.updateWordCount()
    setTimeout(() => createIcons({ icons }), 0)
  }

  updateWordCount() {
    if (!this.hasWordCountTarget || !this.hasContentTarget) return

    const text = this.contentTarget.textContent || ''
    const words = text.trim() ? text.trim().split(/\s+/).length : 0
    this.wordCountTarget.textContent = words.toLocaleString()
  }

  downloadPdf() {
    const content = this.hasContentTarget ? this.contentTarget.innerHTML : ''
    const font = this.fontFamilyValue

    const printWindow = window.open('', '_blank')
    printWindow.document.write(`
      <!DOCTYPE html>
      <html>
      <head>
        <title>${this.projectTitleValue}</title>
        <link href="https://fonts.googleapis.com/css2?family=EB+Garamond:ital,wght@0,400;0,700;1,400&family=Libre+Baskerville:ital,wght@0,400;0,700;1,400&family=Noto+Serif:ital,wght@0,400;0,700;1,400&display=swap" rel="stylesheet">
        <style>
          @page {
            margin: 1in;
            size: letter;
          }
          body {
            font-family: "${font}", serif;
            font-size: 12pt;
            line-height: 1.6;
            max-width: 6.5in;
            margin: 0 auto;
          }
          h1 { font-size: 24pt; margin-bottom: 0.5em; }
          h2 { font-size: 18pt; margin-top: 1.5em; margin-bottom: 0.5em; }
          p { margin-bottom: 0.5em; text-indent: 0.5in; }
          p:first-of-type { text-indent: 0; }
          blockquote {
            margin: 1em 2em;
            font-style: italic;
          }
        </style>
      </head>
      <body>${content}</body>
      </html>
    `)
    printWindow.document.close()
    printWindow.onload = () => {
      printWindow.print()
    }
  }
}
